module.exports = __webpack_public_path__ + "img/tractorUnitRearRight.604b2ee1.svg";